<template>
  <page-layout :title="titleSurvey" v-if="isChildComponentLoaded">
    <div>
      <div>
        <TitleSurvey
          :step="step"
          @clickStepSurvey="clickStepSurvey"
          :isReadOnly="isReadOnly"
        ></TitleSurvey>
      </div>
      <div>
        <md-card>
          <md-card-content>
            <GerneralInformation
              v-if="step === 1"
              @goToStructure="goToStructure"
              :data="gerneralData"
              :isEditPage="isEditPage"
              :isReadOnly="isReadOnly"
              :isCloneSurvey="isCloneSurvey"
              :isRoleTeacher="isRoleTeacher"
            ></GerneralInformation>
            <SurveyStructure
              v-if="step === 2"
              @goToEmail="goToEmail"
              @backToGerneral="backToGerneral"
              :data="structureData"
              :isEditPage="isEditPage"
              :isReadOnly="isReadOnly"
              :isCloneSurvey="isCloneSurvey"
            ></SurveyStructure>
            <EmailContent
              v-if="step === 3"
              @backToStructure="backToStructure"
              :data="emailData"
              ref="emailData"
              :isEditPage="isEditPage"
              :isReadOnly="isReadOnly"
              :isCloneSurvey="isCloneSurvey"
            ></EmailContent>
          </md-card-content>
        </md-card>
        <div
          class="md-layout-item md-size-100 flex justify-center gap-4 mt-5"
          v-if="step === 3"
        >
          <md-button class="md-raised" @click="cancel">
            {{ $t("common.cancel") }}
          </md-button>
          <md-button
            class="md-warning"
            @click="saveSurvey('Pending')"
            v-if="!isReadOnly"
          >
            {{ $t("common.save") }}
          </md-button>
          <md-button
            class="md-success"
            @click="saveSurvey('Activated')"
            v-if="!isReadOnly"
          >
            {{ $t("progress_report.save_and_send_email") }}
          </md-button>
        </div>
      </div>
    </div>
  </page-layout>
</template>
<script>
import GerneralInformation from "./FormSurvey/GerneralInformation";
import SurveyStructure from "./FormSurvey/SurveyStructure";
import EmailContent from "./FormSurvey/EmailContent";
import PageLayout from "../PageLayout.vue";
import { service_names } from "@/constants/Services";
import TitleSurvey from "./FormSurvey/TittleSurvey.vue";
import { survey_router_names } from "@/routes/routes";
import { Survey } from "@/constants/Permissions";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters } from "vuex";
export default {
  components: {
    GerneralInformation,
    SurveyStructure,
    EmailContent,
    TitleSurvey,
    PageLayout
  },
  props: ["isEditPage", "isCloneSurvey"],
  data() {
    return {
      step: 1,
      gerneralData: "",
      structureData: [],
      emailData: "",
      gerneralDataForAdd: {},
      isChildComponentLoaded: false,
      status: "",
      surveyTitle: ""
    };
  },
  created() {
    if (this.isEditPage || this.isCloneSurvey) {
      this.fetchSurvey();
    } else {
      this.isChildComponentLoaded = true;
    }
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    }),
    titleSurvey() {
      if (this.isEditPage) {
        return this.$t("survey.edit_survey");
      }
      if (this.isCloneSurvey) {
        return this.$t("survey.clone_survey") + " " + this.surveyTitle;
      }
      return this.$t("survey.add_survey");
    },
    surveyId() {
      return this.$route.params.id;
    },
    isReadOnly() {
      return (
        (this.$can(Survey.actions.view, Survey.subject) ||
          hasValidRole(this.userRole, Role.Teacher)) &&
        this.isEditPage &&
        this.status !== "Pending"
      );
    },
    isRoleTeacher() {
      return hasValidRole(this.userRole, Role.Teacher);
    }
  },

  methods: {
    cancel() {
      this.$router.push({ name: survey_router_names.listPage });
    },
    backToGerneral(data) {
      this.structureData = data;
      this.step = 1;
    },
    goToStructure(data) {
      this.gerneralData = data;
      this.step = 2;
    },
    goToEmail(data) {
      this.structureData = data;
      this.step = 3;
    },
    backToStructure(data) {
      this.emailData = data;
      this.step = 2;
    },
    clickStepSurvey(stepClick) {
      this.step = stepClick;
    },
    formatDataGerneral() {
      const respondentGerneral = this.gerneralData.gerneralLocal.respondent;
      const respondentSetting = this.gerneralData.gerneral_information
        .respondent_setting;
      for (let item in respondentGerneral) {
        if (respondentGerneral[item] === null) {
          delete respondentSetting[item];
        }
      }
      if (respondentSetting.student?.filter === "student") {
        delete respondentSetting.student.status;
      }
      if (
        respondentSetting.family?.filter === "student" ||
        respondentSetting.family?.filter === "family"
      ) {
        delete respondentSetting.family.status;
      }
      if (respondentSetting.teacher?.filter === "teacher") {
        delete respondentSetting.teacher.status;
      }
    },
    async fetchSurvey() {
      const response = await this.$axios.get(
        `${service_names.school}/survey/${this.surveyId}`,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      const surveyData = response.data;
      this.status = surveyData.status;
      this.surveyTitle = surveyData.gerneral_information.title;
      this.gerneralData = {
        gerneral_information: surveyData.gerneral_information,
        option_selected: surveyData.list_edit,
        create_by: surveyData.create_by
      };
      this.structureData = surveyData.survey_structure;
      this.emailData = surveyData.email_content;
      this.isChildComponentLoaded = true;
    },
    saveSurvey(statusSurvey) {
      this.formatDataGerneral();
      this.emailData = this.$refs.emailData.content;
      let dataSurvey = {
        status: statusSurvey,
        gerneral_information: this.gerneralData.gerneral_information,
        survey_structure: { questions: this.structureData },
        email_content: this.emailData
      };
      if (this.isEditPage) {
        this.$emit("on-submit-edit", dataSurvey);
      }
      if (this.isCloneSurvey) {
        this.$emit("on-submit-clone", dataSurvey);
      } else {
        this.$emit("on-submit", dataSurvey);
      }
    }
  }
};
</script>
